import React from 'react';
import { Box } from '@mui/material';
import ContentText from '../../common/atoms/ContentText';
import textData from '../../../json/text.json';
import colorData from '../../../json/color.json';
import ImageWithTitle from '../atoms/ImageWithTitle';
import type {Achievement} from '../../../types/types';

interface Props {
  achievements: Achievement[];
}

/**
 * 実績
 * @returns 
 */
const RecordSelection: React.FC<Props> = ({achievements}) => {

  const boxStyle = {
    margin: '5px 30px 20px 30px',
    backgroundColor: colorData['royalblue'],
    padding: '10px',
    width: '500px'
  };

  return (
    <Box>
      <ContentText text={textData['works.text']['ja']}/>
      <Box sx={{mt:10}}></Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: { xs:'column', lg: 'row' },
          justifyContent: "center",
          mt: 5,
          alignItems: 'center',
          width: '100%',
        }}
      >
        {achievements.map((items, index) =>(
          <Box key={index} sx={boxStyle}>
            <ImageWithTitle imageUrl={items.imageUrl} title={items.title} linkTo={items.linkTo} contentsCount={2}/>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RecordSelection;
